import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { JdFormItemComponent } from './form-item.component';

@Component({
  selector: 'jd-form-explain',
  template: `
    <div [@formExplainAnimation]>
      <ng-content></ng-content>
    </div>
  `,
  animations: [
    trigger('formExplainAnimation', [
      transition('void => *', [
        style({
          opacity: 0,
          transform: 'translateY(-5px)'
        }),
        animate('0.3s cubic-bezier(0.645, 0.045, 0.355, 1)', style({
          opacity: 1,
          transform: 'translateY(0)'
        }))
      ]),
      transition('* => void', [
        style({
          opacity: 1,
          transform: 'translateY(0)'
        }),
        animate('0.3s cubic-bezier(0.645, 0.045, 0.355, 1)', style({
          opacity: 0,
          transform: 'translateY(-5px)'
        }))
      ])
    ])
  ],
  host: {
    '[class.ant-form-explain]': 'true'
  },
  styles: [
      `:host {
      display: block;
    }`
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JdFormExplainComponent implements OnInit, OnDestroy {
  constructor(private jdFormItemComponent: JdFormItemComponent) {
  }

  ngOnDestroy(): void {
    this.jdFormItemComponent.disableHelp();
  }

  ngOnInit(): void {
    this.jdFormItemComponent.enableHelp();
  }

}
